// SPDX-License-Identifier: AGPL-3.0-only
import { z } from 'zod';
/**
 * The eighteen canonical data-contract shapes. Server payloads and widget
 * data contracts discriminate on these keys.
 */
export const DATA_SHAPES = [
    'single-metric',
    'metric+delta',
    'timeseries',
    'multi-timeseries',
    'categorical',
    'record-list',
    'record',
    'matrix',
    'hierarchy/tree',
    'calendar-events',
    'geo-points',
    'flows',
    'ohlc',
    'distribution',
    'boolean-map',
    'stream',
    'form-state',
    'static',
];
export const dataShapeSchema = z.enum(DATA_SHAPES);
/**
 * The subset of {@link DATA_SHAPES} the widget-data query compiler can actually
 * produce today; the rest reject with 422. SINGLE SOURCE OF TRUTH for that
 * boundary:
 *
 *  - `apps/server/src/widget-data/compiler.ts` validates requested shapes
 *    against it, and
 *  - `registry/llm-allowlist.ts` refuses to offer the enrichment prompt a
 *    widget whose data contract lies outside it.
 *
 * Those two had drifted apart, which is how the LLM came to be offered 17
 * widgets (chart-sankey, chart-multiline, the matrix family…) that no binding
 * could ever satisfy. Extending the compiler therefore widens the prompt
 * vocabulary automatically — add the shape here in the same change.
 *
 * Two of the eighteen are NOT compiler gaps and must never be listed here:
 * `static` is config-only with no server round trip, and `form-state` is fed
 * by the CRUD form path, not by a query descriptor. With the last five
 * (`hierarchy/tree`, `geo-points`, `flows`, `boolean-map`, `ohlc`) compiled,
 * those two are all that remain outside — the list below is the whole backlog,
 * closed.
 */
export const COMPILABLE_DATA_SHAPES = [
    'single-metric',
    'metric+delta',
    'timeseries',
    'multi-timeseries',
    'categorical',
    'record-list',
    'record',
    'matrix',
    'hierarchy/tree',
    'calendar-events',
    'geo-points',
    'flows',
    'ohlc',
    'distribution',
    'boolean-map',
    'stream',
];
export function isCompilableShape(shape) {
    return COMPILABLE_DATA_SHAPES.includes(shape);
}
//# sourceMappingURL=data-shapes.js.map